import { deleteItemFromOneDrive } from "src/graph";
import { useMS } from "../context/MSContext";
import toast from "react-hot-toast";
import { AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader, AlertDialogAction, AlertDialogCancel, AlertDialogDescription, AlertDialogFooter, AlertDialogTitle } from "src/components/ui/alert-dialog";
import { Trash2 } from "lucide-react";

type UTF = {
    selected_documents: string[]
    onedrivedocuments:any[]
    onSuccess?: () => void;
}

export const RemoveFromDrive = ({selected_documents, onedrivedocuments, onSuccess}:UTF) => {
    const { accessToken } = useMS()

    async function handleRemoveDocuments () {
        try {
            const deletePromises = selected_documents.map(async (id:string) => {
                await deleteItemFromOneDrive(accessToken, id);  
            });
            await Promise.all(deletePromises);

            onSuccess && onSuccess();
            toast.remove('updateDocuments');
        } catch (error:any) {
            console.log(error);
            toast.error('Documenten verwijderen mislukt', { id:'removeDocuments' })
        }
    }

    return (
        <AlertDialog>
            <AlertDialogTrigger asChild>
                <button disabled={selected_documents.length === 0} className='flex items-center gap-2 text-sm rounded-sm p-2 group hover:bg-neutral-100 disabled:opacity-50'><Trash2 className='w-4 h-4 group-hover:text-primary' strokeWidth={1.25}/>Verwijderen</button>
            </AlertDialogTrigger>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Let op! Documenten verwijderen</AlertDialogTitle>
                    <AlertDialogDescription>U staat op het punt om {selected_documents.length} document{selected_documents.length > 1 && 'en'} te verwijderen uit OneDrive</AlertDialogDescription>
                </AlertDialogHeader>

                <AlertDialogFooter>
                    <AlertDialogCancel>Annuleren</AlertDialogCancel>
                    <AlertDialogAction onClick={()=>{handleRemoveDocuments()}}>Verwijderen</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}